import {
  AppPageHeader,
  ColumnsType,
  DeleteIcon,
  EditIcon,
  InfiniteTable,
} from '@/components/_common';
import {
  useDeleteWorkOrderTag,
  useWorkOrdersTags,
} from '@/core/domain/workorder/WorkOrderTags/WorkOrdersTags.hooks';
import {
  WorkOrderTag,
  WorkOrderTagsQueryFilter,
} from '@/core/domain/workorder/WorkOrderTags/WorkOrdersTags.types';
import { useDebounce, useDisclosure } from '@/hooks';
import { usePersistSearchParams } from '@/utils/queryParams';
import convertParams from '@/utils/queryParams/convertParams';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Divider, Modal, Space, Tag } from 'antd';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import TagsWorkOrderModal from '../TagsWorkOrderModal';

export default function TagsWorkOrderList() {
  const intl = useIntl();

  const [queryParams, setQueryParams] = useState<WorkOrderTagsQueryFilter>({
    order: 'ASC',
    ...convertParams<WorkOrderTagsQueryFilter>({
      search: 'string',
    }),
  });
  const [tagSelected, setTagSelected] = useState<WorkOrderTag>();
  const [modalEditOpened, modalEditActions] = useDisclosure();

  const queryDebounce = useDebounce(queryParams, 500);
  usePersistSearchParams(queryDebounce);

  const { data, isFetching, fetchNextPage, hasNextPage } =
    useWorkOrdersTags(queryDebounce);

  const workOrderTags = flatInfiniteData(data);

  const { mutateAsync: deleteWorkOrderTagMutate } = useDeleteWorkOrderTag();

  const handleRemoveClick = (id: number) => {
    Modal.confirm({
      title: 'Atenção!',
      content: 'Deseja realmente excluir essa etiqueta?',
      onOk: async () => {
        await deleteWorkOrderTagMutate(id);
      },

      okType: 'danger',
    });
  };

  const columns: ColumnsType<WorkOrderTag> = [
    {
      dataIndex: 'name',
      title: 'Descrição',
      render: (_, record) => (
        <Tag color={record.color}>{record.name.toUpperCase()}</Tag>
      ),
    },
    {
      dataIndex: 'actions',
      title: intl.formatMessage({ id: 'customers.list.header.actions' }),
      render: (_, row) => (
        <Space>
          <EditIcon
            iconProps={{
              onClick: () => {
                setTagSelected(row);
                modalEditActions.open();
              },
            }}
          />

          <Divider type="vertical" />

          <DeleteIcon onClick={() => handleRemoveClick(row.id)} />
        </Space>
      ),
      width: 100,
      align: 'right',
      fixed: 'right',
    },
  ];

  return (
    <>
      <AppPageHeader
        onSearch={(value) =>
          setQueryParams((prev) => ({ ...prev, search: value }))
        }
      />

      <InfiniteTable<WorkOrderTag>
        columns={columns}
        dataSource={workOrderTags}
        loading={isFetching}
        rowKey={(row) => row.id}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
      />

      <TagsWorkOrderModal
        tagDetail={tagSelected}
        open={modalEditOpened}
        onCancel={() => {
          modalEditActions.close();
          setTagSelected(undefined);
        }}
      />
    </>
  );
}
